import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const pains = ['Trabajas más de 50 horas a la semana pero el dinero nunca alcanza.', 'Sientes que Dios te llamó a algo más grande pero no sabes por dónde empezar.', 'Tienes miedo de abrir un negocio por no entender el sistema legal en EE.UU.', 'Has intentado emprender antes pero sin un sistema claro, fracasaste.', 'Sientes culpa por querer prosperar, como si el dinero y la fe no pudieran ir juntos.', 'Llegas a casa agotado y sin tiempo para tu familia ni para Dios.'];
export function PainSection() {
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="border-l-4 border-gold pl-6 md:pl-10" data-id="element-105">
          <h2 className="text-3xl md:text-4xl text-navy mb-10" data-id="element-106">
            ¿Te identificas con alguno de estos?
          </h2>

          <ul className="space-y-6 mb-10" data-id="element-107">
            {pains.map((pain, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 text-lg md:text-xl text-charcoal" data-id="element-108">
                <X className="w-6 h-6 text-urgency flex-shrink-0 mt-1" data-id="element-109" />
                <span data-id="element-110">{pain}</span>
              </motion.li>)}
          </ul>

          <p className="text-xl md:text-2xl italic text-navy font-semibold leading-relaxed" data-id="element-111">
            Si dijiste "sí" a más de uno... lo que te falta no es más fe. Es un
            sistema. Y eso es exactamente lo que encontrarás aquí.
          </p>
        </motion.div>
      </div>
    </section>;
}